<script setup lang="ts">
const props = defineProps<{
  type: 'advisor' | 'brand'
  quote: string
  name: string
  position: string
  company: string
  avatar: string
  logo: string
}>()

const isBrand = computed(() => props.type === 'brand')

const initials = computed(() =>
  props.name
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase()
)
</script>

<template>
  <figure
    :class="$cn(['flex h-full flex-col rounded-lg p-7', isBrand ? 'ring-2 ring-inset ring-slate-100' : 'bg-slate-50'])"
  >
    <span
      v-if="logo"
      class="flex h-6 items-center"
    >
      <img
        :src="logo"
        :alt="company || name"
        class="max-h-6"
      />
    </span>

    <svg
      v-else
      class="size-6 flex-none text-slate-300"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path
        d="M9.5 5C6.5 6.6 4.6 9.6 4.6 13.2c0 3.2 2 5.3 4.6 5.3 2.3 0 3.9-1.7 3.9-3.9 0-2.2-1.6-3.8-3.6-3.8-.4 0-.9.1-1 .1.3-1.6 1.9-3.5 3.8-4.5L9.5 5Zm9.4 0c-3 1.6-4.9 4.6-4.9 8.2 0 3.2 2 5.3 4.6 5.3 2.3 0 3.9-1.7 3.9-3.9 0-2.2-1.6-3.8-3.6-3.8-.4 0-.9.1-1 .1.3-1.6 1.9-3.5 3.8-4.5L18.9 5Z"
      />
    </svg>

    <blockquote class="leading-relaxed' mt-4 flex-1 font-medium">
      "{{ quote }}"
    </blockquote>

    <figcaption class="mt-6 flex items-center gap-3">
      <img
        v-if="avatar"
        :src="avatar"
        :alt="name"
        class="size-10 flex-none rounded-full object-cover"
      />
      <span
        v-else
        class="flex size-10 flex-none items-center justify-center rounded-full bg-slate-50 text-sm font-semibold text-slate-500"
      >
        {{ initials }}
      </span>
      <span class="text-xs text-slate-500">
        <span class="text-sm font-semibold text-paragraph">{{ name }}</span>
        <div
          v-if="position || company"
          class="flex flex-wrap"
        >
          <span v-if="position">{{ position }}{{ company && ',&nbsp;' }}</span>
          <span v-if="company">{{ company }}</span>
        </div>
      </span>
    </figcaption>
  </figure>
</template>
